import { useMemo } from 'react'
import useWheelId from './useWheelId'

/**
 * Возвращает реальный ключ хранилища на основе текущего wheelId:
 * - 'me' → 'wheel' (ключ по умолчанию для данных пользователя)
 * - 'my' → 'wheel' (для первого хранилища)
 * - Другой UUID → возвращается как есть
 */
export default function useActualWheelId(): string {
    const pathWheelId = useWheelId();

    return useMemo(() => {
        // Для 'my' и 'me' используем ключ 'wheel'
        if (pathWheelId === 'my') {
            return 'wheel';
        }

        // Для остальных путей возвращаем UUID как есть
        return pathWheelId;
    }, [pathWheelId]);
}
